import "bootstrap-italia/dist/css/bootstrap-italia.min.css";
import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "typeface-lora";
import "typeface-roboto-mono";
import "typeface-titillium-web";
import "./App.css";
import CustomFooter from "./components/CustomFooter/CustomFooter";
import CustomForm from "./components/CustomForm/CustomForm";
import CustomHeader from "./components/CustomHeader/CustomHeader";
import Done from "./components/Done/Done";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import UserValidation from "./components/UserValidation/UserValidation";

const App = () => {
  const { pathname } = useLocation();

  return (
    <>
      <CustomHeader preTitle="Dipartimento della Funziona Pubblica" title="Portale PIAO" tagLine="Piano Integrato di Attività e Organizzazione" />

      <main style={{ padding: "20px"  }}>
        <Routes>
          <Route path="/" element={<CustomForm />} />
          <Route path="validazione/*" element={<UserValidation />} />
           <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route
            path="/done"
            element={
              <Done
                title="Esito"
                body="La tua richiesta è stata presa in carico"
                icon="it-info-circle"
              />
            }
          />
          <Route
            path="*"
            element={
              <div style={{ padding: "1rem" }}>
                <p>Pagina non trovata!</p>
              </div>
            }
          />
        </Routes>
      </main>
      <CustomFooter />
    </>
  );
};

export default App;
